<!-- 🟣 Ticket Modal -->
<div
  class="modal fade"
  id="ticketModal"
  tabindex="-1"
  aria-labelledby="ticketModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header bg-linear-gradient-purple text-white border-0">
        <h5 class="modal-title fw-semibold" id="ticketModalLabel">
          <i class="bi bi-ticket-detailed me-2"></i> Submit a Support Ticket
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body p-4">
        <!-- Page Dropdown -->
        <div class="mb-3">
          <label class="form-label fw-semibold">Where did the issue occur?</label>
          <select class="form-select" [(ngModel)]="selectedPage">
            <option value="" disabled selected>Select a page...</option>
            <option *ngFor="let page of pages" [value]="page">{{ page }}</option>
          </select>
        </div>

        <!-- Description -->
        <div class="mb-3">
          <label class="form-label fw-semibold">Brief Description</label>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="description"
            placeholder="Describe what happened..."
          ></textarea>
        </div>

        <!-- Upload -->
        <div class="mb-4">
          <label class="form-label fw-semibold">Attach Screenshot (optional)</label>
          <input
            type="file"
            id="ticketFile"
            class="form-control"
            accept="image/*"
            (change)="onFileSelected($event)"
          />
          <div *ngIf="imageFile" class="mt-2 text-success small">
            <i class="bi bi-image me-1"></i>{{ imageFile.name }}
          </div>
        </div>

        <!-- Submit -->
        <div class="text-center">
          <button class="btn btn-gradient btn-lg px-5" (click)="submitTicket()">
            <i class="bi bi-send me-2"></i> Submit Ticket
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ✅ Success Modal -->
<div class="modal fade" id="successModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-success text-white">
        <h5 class="modal-title fw-semibold">
          <i class="bi bi-check-circle-fill me-2"></i> Ticket Submitted
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="closeModal('successModal')"
        ></button>
      </div>
      <div class="modal-body text-center py-4">
        <p>Your ticket has been submitted successfully. Our team will review it soon.</p>
      </div>
      <div class="modal-footer justify-content-center border-0 pb-4">
        <button class="btn btn-gradient btn-lg px-5" (click)="closeModal('successModal')">
          OK
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ❌ Error Modal -->
<div class="modal fade" id="errorModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title fw-semibold">
          <i class="bi bi-exclamation-triangle-fill me-2"></i> Missing Information
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          (click)="closeModal('errorModal')"
        ></button>
      </div>
      <div class="modal-body text-center py-4">
        <p>Please select a page and enter a brief description before submitting.</p>
      </div>
      <div class="modal-footer justify-content-center border-0 pb-4">
        <button class="btn btn-gradient btn-lg px-5" (click)="closeModal('errorModal')">
          OK
        </button>
      </div>
    </div>
  </div>
</div>
